import Reveal from '@/components/base/Reveal';
import { updateItems } from '@/mocks/home';

const toneClass: Record<string, string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-400 text-foreground-950',
  secondary: 'bg-secondary-400 text-foreground-950',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="scroll-mt-24 bg-foreground-950 py-16 md:py-24">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3">
              <span className="font-label text-xs font-semibold tracking-[0.3em] text-accent-400">
                05
              </span>
              <span className="h-px w-8 bg-accent-400/60" />
              <span className="font-label text-xs font-medium tracking-[0.2em] text-background-100/70">
                WHAT&apos;S NEXT
              </span>
            </div>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
              后续进度：这件事现在走到哪了
            </h2>
            <p className="mt-4 font-body text-sm leading-relaxed text-background-100/75 md:text-base">
              补课不是一次性读完就结束。每条进度都带着日期和状态，你可以直接看最新一条，判断自己掌握的信息有没有过期。
            </p>
          </div>
          <div className="shrink-0 rounded-lg border border-background-50/15 bg-background-50/5 px-5 py-4">
            <p className="font-label text-xs tracking-wide text-background-100/60">最近更新</p>
            <p className="mt-1 font-heading text-lg font-bold text-background-50">09 / 30</p>
            <p className="mt-1 font-body text-xs text-background-100/60">共 6 条进度 · 持续追加</p>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
          {updateItems.map((item, i) => (
            <Reveal key={`${item.date}-${item.title}`} delay={i * 70}>
              <article className="h-full rounded-lg border border-background-50/12 bg-background-50/5 p-5 transition-colors hover:border-accent-400/50 hover:bg-background-50/10 md:p-6">
                <div className="flex items-center justify-between gap-3">
                  <time className="font-heading text-sm font-bold tracking-wide text-background-50">
                    {item.date}
                  </time>
                  <span
                    className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-1 font-label text-[11px] font-semibold ${toneClass[item.tone]}`}
                  >
                    {item.status}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold leading-snug text-background-50">
                  {item.title}
                </h3>
                <p className="mt-2 font-body text-xs leading-relaxed text-background-100/70 md:text-sm">
                  {item.desc}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}